import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'licence.Licences' | translate }}</h1>
            <a class="btn add" ui-sref="authorized.manage.settings.licences.add()">{{ 'licence.Add licence' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')">
                            <a ng-click="vm.list.sortBy('name')">{{ 'licence.Licence' | translate }}</a>
                        </th>
                        <th>{{ 'licence.Current period points entering deadline' | translate }}</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>{{ item.name }}</a></td>
                        <td>{{ item.closestLicencePeriod.enteringDate | date : 'dd.MM.yyyy' }}</td>
                        <td class="actions">
                            <a class="btn edit" ui-sref="authorized.manage.settings.licences.detail({ id: item.id})"
                        >{{ 'licence.Edit' | translate }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor (DATATABLES, ListFactory, LicenceResource) {
        this.DATATABLES = DATATABLES;
        this.list = ListFactory.createWithPagination(LicenceResource.query.bind(LicenceResource));
        this.list.fetch({ expand: 'closestLicencePeriod' });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/licences/list/index.js